import { reviewsDataProvider } from './reviewsDataProvider';
import { adsModerationDataProvider, adsExpertModerationDataProvider } from './adsModerationDataProvider';
import { complaintsDataProvider } from './complaintsDataProvider';
import { ordersDataProvider } from './ordersDataProvider';
import { customReasonsDataProvider } from './customReasonsDataProvider';
import { usersDataProvider } from './usersDataProvider';
import { adminUsersDataProvider } from './adminUsersDataProvider';
import { userAdsDataProvider } from './userAdsDataProvider';

export const universalDataProvider = {
    ...reviewsDataProvider,
    getList: (resource: string, params: any) => {
        if (resource === 'adsModeration') {
            return adsModerationDataProvider.getList(resource, params);
        }
        if (resource === 'adsExpertModeration') {
            return adsExpertModerationDataProvider.getList(resource, params);
        }
        if (resource === 'complaints') {
            return complaintsDataProvider.getList(resource, params);
        }
        if (resource === 'orders') {
            return ordersDataProvider.getList(resource, params);
        }
        if (resource === 'users') {
            return usersDataProvider.getList(resource, params);
        }
        if (resource === 'customReasons') {
            return customReasonsDataProvider.getList(resource, params);
        }
        if (resource === 'adminUsers') {
            return adminUsersDataProvider.getList(resource, params);
        }
        return reviewsDataProvider.getList(resource, params);
    },
    getOne: (resource: string, params: any) => {
        if (resource === 'adsModeration') {
            // getOne для объявлений можно реализовать по необходимости
            return Promise.reject('Not implemented');
        }
        if (resource === 'complaints') {
            return complaintsDataProvider.getOne(resource, params);
        }
        if (resource === 'orders') {
            return ordersDataProvider.getOne(resource, params);
        }
        if (resource === 'users') {
            return usersDataProvider.getOne(resource, params);
        }
        if (resource === 'userAds') {
            return userAdsDataProvider.getOne(resource, params);
        }
        if (resource === 'adminUsers') {
            return adminUsersDataProvider.getOne(resource, params);
        }
        return reviewsDataProvider.getOne(resource, params);
    },
    create: (resource: string, params: any) => {
        if (resource === 'customReasons') {
            return customReasonsDataProvider.create(resource, params);
        }
        if (resource === 'adminUsers') {
            return adminUsersDataProvider.create(resource, params);
        }
        return Promise.reject('Not implemented');
    },
    update: (resource: string, params: any) => {
        if (resource === 'complaints') {
            return complaintsDataProvider.update(resource, params);
        }
        if (resource === 'customReasons') {
            return customReasonsDataProvider.update(resource, params);
        }
        if (resource === 'adminUsers') {
            return adminUsersDataProvider.update(resource, params);
        }
        return Promise.reject('Not implemented');
    },
    delete: (resource: string, params: any) => {
        if (resource === 'customReasons') {
            return customReasonsDataProvider.delete(resource, params);
        }
        if (resource === 'adminUsers') {
            return adminUsersDataProvider.delete(resource, params);
        }
        return Promise.reject('Not implemented');
    },
    // Остальные методы (create, delete) можно добавить аналогично при необходимости
};
